import { GlobalOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import type { Language } from '../../i18n';

/**
 * Language toggle for the header. Changing the language re-renders the whole tree through
 * react-i18next and flips antd into RTL, so no reload is needed — and the choice is persisted to
 * localStorage by the detector, so it survives the next visit.
 */
export default function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  const current = i18n.language.startsWith('ur') ? 'ur' : 'en';

  return (
    <Dropdown
      menu={{
        selectedKeys: [current],
        items: [
          { key: 'en', label: t('common.english') },
          { key: 'ur', label: t('common.urdu') },
        ],
        onClick: ({ key }) => void i18n.changeLanguage(key as Language),
      }}
    >
      <span
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
        title={t('common.language')}
      >
        <GlobalOutlined />
        {current === 'ur' ? t('common.urdu') : t('common.english')}
      </span>
    </Dropdown>
  );
}
